import { defineStore } from "pinia";
import { ref } from "vue";

type ClassesState = Record<string, string[]>;

type SetClassnamePayload = {
  position: string;
  className: string;
};

export const useClassesStore = defineStore("classes", () => {
  const classes = ref<ClassesState>({});

  const getClasses = (position: string): string[] => {
    return classes.value[position] || [];
  };

  const setClassnameByPosition = ({ position, className }: SetClassnamePayload): void => {
    if (!classes.value[position]) {
      classes.value[position] = [];
    }
    classes.value[position]?.push(className);
  };

  const addBodyClassname = (className: string): void => {
    document.body.classList.add(className);
  };

  const removeBodyClassname = (className: string): void => {
    document.body.classList.remove(className);
  };

  return {
    classes,
    getClasses,
    setClassnameByPosition,
    addBodyClassname,
    removeBodyClassname,
  };
});
